/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Specialists_Show_AllInputs */

const en_portal_specialists_show_all = /** @type {(inputs: Portal_Specialists_Show_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show everyone`)
};

const pl_portal_specialists_show_all = /** @type {(inputs: Portal_Specialists_Show_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokaż wszystkich`)
};

/**
* | output |
* | --- |
* | "Show everyone" |
*
* @param {Portal_Specialists_Show_AllInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_specialists_show_all = /** @type {((inputs?: Portal_Specialists_Show_AllInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Specialists_Show_AllInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_specialists_show_all(inputs)
	return en_portal_specialists_show_all(inputs)
});